import { futureSummary, historySummary, selectedHistory } from "./teamAnalysis";
export function homeAdvantage(row) {
  const r = futureSummary(row);
  return r && Number.isFinite(r.for_homefactor) && r.against_homefactor > 0
    ? r.for_homefactor / r.against_homefactor
    : null;
}
export function strengthRanking(teams) {
  const rows = Object.entries(teams || {})
    .map(([id, row]) => ({ id: Number(id), ...futureSummary(row) }))
    .filter((r) => Number.isFinite(r.total_strength))
    .sort((a, b) => b.total_strength - a.total_strength || a.id - b.id);
  return rows.map((r) => ({
    ...r,
    rank: rows.findIndex((x) => x.total_strength === r.total_strength) + 1,
  }));
}
export function historicalHomeProfile(observations, id, basis) {
  const games = selectedHistory(observations || [], id, false);
  const home = historySummary(games, id, basis, "home"),
    away = historySummary(games, id, basis, "away");
  if (!home.count || !away.count) return { home, away, advantage: null };
  const row = {
    for_home: home.for_average,
    against_home: home.against_average,
    for_away: away.for_average,
    against_away: away.against_average,
  };
  const s = futureSummary(row);
  return { home, away, ...s, advantage: homeAdvantage(row) };
}
